import { each, equals2, filterL, go, head, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleTouchEndOrCancel = (self, event) => {
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const selection = self._getSelectionThrowable();
  const selection_translate_transform =
    self._getSelectionTranslateTransformThrowable();
  const selection_scale_transform1 =
    self._getSelectionScaleTransform1Throwable();
  const selection_scale_transform2 =
    self._getSelectionScaleTransform2Throwable();
  const selection_rotate_transform =
    self._getSelectionRotateTransformThrowable();
  if (self._touch_map.size <= 0) {
    return;
  }
  event.preventDefault();
  const { changedTouches: changed_touches, touches } = event;
  const changed_touch_map = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    mapL((touch) => [touch.identifier, touch]),
    (entries) => new Map(entries)
  );
  const touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(touches),
    mapL(({ identifier: id }) => id),
    (iter) => new Set(iter)
  );
  const prev_touch_map = self._touch_map;
  self._touch_map = go(
    self._touch_map.entries(),
    rejectL(([id]) => changed_touch_map.has(id)),
    rejectL(([id]) => !touch_id_set.has(id)),
    (entries) => new Map(entries)
  );
  switch (self._processing_task) {
    case PROCESSING_TASK.SELECTING: {
      if (self._selecting_touch_id == null) {
        self._processing_task = null;
        rubber_band.abortSelecting();
        return;
      }
      const touch_id = self._selecting_touch_id;
      if (self._touch_map.has(touch_id)) {
        return;
      }
      const touch = changed_touch_map.get(touch_id);
      if (touch == null) {
        self._processing_task = null;
        self._selecting_touch_id = null;
        rubber_band.abortSelecting();
        return;
      }
      const { clientX: end_client_x, clientY: end_client_y } = touch;
      const rubber_band_layer_ctm = rubber_band_layer_el.getCTM();
      if (rubber_band_layer_ctm == null) {
        throw new Error(
          `rubber_band_layer 엘리먼트의 CTM 을 구할 수 없습니다.`
        );
      }
      const rubber_band_layer_ctm_inverse = rubber_band_layer_ctm.inverse();
      const point = self
        ._toViewPortPoint({
          x: end_client_x,
          y: end_client_y,
        })
        .matrixTransform(rubber_band_layer_ctm_inverse);
      self._processing_task = null;
      self._selecting_touch_id = null;
      rubber_band.endSelecting({
        x: point.x,
        y: point.y,
      });
      return;
    }
    case PROCESSING_TASK.TRANSLATE_TRANSFORMING: {
      if (
        self._translate_transforming_touch_id != null &&
        self._touch_map.has(self._translate_transforming_touch_id)
      ) {
        return;
      }
      self._processing_task = null;
      self._translate_transforming_touch_id = null;
      selection_translate_transform.end();
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING1: {
      if (
        self._scale_transforming1_touch_id != null &&
        self._touch_map.has(self._scale_transforming1_touch_id)
      ) {
        return;
      }
      self._processing_task = null;
      self._scale_transforming1_touch_id = null;
      selection_scale_transform1.end();
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING2: {
      if (
        self._scale_transforming2_touch_id1 != null &&
        self._scale_transforming2_touch_id2 != null &&
        self._touch_map.has(self._scale_transforming2_touch_id1) &&
        self._touch_map.has(self._scale_transforming2_touch_id2)
      ) {
        return;
      }
      if (
        (self._scale_transforming2_touch_id1 == null ||
          !self._touch_map.has(self._scale_transforming2_touch_id1)) &&
        (self._scale_transforming2_touch_id2 == null ||
          !self._touch_map.has(self._scale_transforming2_touch_id2))
      ) {
        self._processing_task = null;
        self._scale_transforming2_touch_id1 = null;
        self._scale_transforming2_touch_id2 = null;
        selection_scale_transform2.end();
        return;
      }
      if (
        self._scale_transforming2_touch_id1 == null ||
        !self._touch_map.has(self._scale_transforming2_touch_id1)
      ) {
        self._scale_transforming2_touch_id1 = null;
      }
      if (
        self._scale_transforming2_touch_id2 == null ||
        !self._touch_map.has(self._scale_transforming2_touch_id2)
      ) {
        self._scale_transforming2_touch_id2 = null;
      }
      return;
    }
    case PROCESSING_TASK.ROTATE_TRANSFORMING: {
      if (
        self._rotate_transforming_touch_id != null &&
        self._touch_map.has(self._rotate_transforming_touch_id)
      ) {
        return;
      }
      self._processing_task = null;
      self._rotate_transforming_origin_x = 0;
      self._rotate_transforming_origin_y = 0;
      self._rotate_transforming_touch_id = null;
      selection_rotate_transform.end();
      return;
    }
    case PROCESSING_TASK.ZOOMING_AND_PANNING:
    case PROCESSING_TASK.PATH_EDITING_ZOOMING_AND_PANNING: {
      if (
        self._zooming_and_panning_touch_id1 != null &&
        self._zooming_and_panning_touch_id2 != null &&
        self._touch_map.has(self._zooming_and_panning_touch_id1) &&
        self._touch_map.has(self._zooming_and_panning_touch_id2)
      ) {
        return;
      }
      if (
        (self._zooming_and_panning_touch_id1 == null ||
          !self._touch_map.has(self._zooming_and_panning_touch_id1)) &&
        (self._zooming_and_panning_touch_id2 == null ||
          !self._touch_map.has(self._zooming_and_panning_touch_id2))
      ) {
        self._processing_task = equals2(self._processing_task)(
          PROCESSING_TASK.PATH_EDITING_ZOOMING_AND_PANNING
        )
          ? PROCESSING_TASK.PATH_EDITING
          : null;
        self._zooming_and_panning_touch_id1 = null;
        self._zooming_and_panning_touch_id2 = null;
        self._zooming_and_panning_progress_touch_x1 = 0;
        self._zooming_and_panning_progress_touch_y1 = 0;
        self._zooming_and_panning_progress_touch_x2 = 0;
        self._zooming_and_panning_progress_touch_y2 = 0;
        return;
      }
      if (
        self._zooming_and_panning_touch_id1 == null ||
        !self._touch_map.has(self._zooming_and_panning_touch_id1)
      ) {
        self._zooming_and_panning_touch_id1 = null;
      }
      if (
        self._zooming_and_panning_touch_id2 == null ||
        !self._touch_map.has(self._zooming_and_panning_touch_id2)
      ) {
        self._zooming_and_panning_touch_id2 = null;
      }
      return;
    }
    case PROCESSING_TASK.PATH_EDITING: {
      if (self._touch_map.size > 0) {
        return;
      }
      const touch = go(
        changed_touch_map.values(),
        filterL((touch) => prev_touch_map.has(touch.identifier)),
        head
      );
      if (touch == null) {
        return;
      }
      const { target } = touch;
      if (!(target instanceof self._window.Node)) {
        return;
      }
      const target_node = target;
      go(
        self._path_editor_list,
        mapL(({ view }) => view),
        each((view) => view.click(target_node))
      );
      return;
    }
    case PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING: {
      if (
        self._path_editing_touch_id != null &&
        self._touch_map.has(self._path_editing_touch_id)
      ) {
        return;
      }
      self._processing_task = PROCESSING_TASK.PATH_EDITING;
      self._path_editing_touch_id = null;
      self._path_editing_progress_touch_x = 0;
      self._path_editing_progress_touch_y = 0;
      return;
    }
    case null: {
      if (self._touch_map.size <= 0) {
        const touch = go(
          changed_touch_map.values(),
          filterL((touch) => prev_touch_map.has(touch.identifier)),
          head
        );
        if (touch == null) {
          return;
        }
        const selectable_el = selection.convertToSelectableEl(touch.target);
        selection.setSelectedEls(selectable_el == null ? [] : [selectable_el]);
      }
      return;
    }
    default: {
      return;
    }
  }
};
